import React from 'react';
import { motion } from 'framer-motion';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../../components/ui/Accordion";

const faqs = [
  {
    question: "What makes CipherGenix different from traditional cybersecurity solutions?",
    answer: "CipherGenix provides complete healthcare AI lifecycle protection specifically designed for clinical environments. Unlike traditional security tools, our platform addresses AI-specific threats like adversarial attacks, data poisoning, and model theft with 99.8% threat detection accuracy."
  },
  {
    question: "Is CipherGenix compliant with healthcare regulations?",
    answer: "Yes. Our platform is designed with HIPAA, HITECH, and FDA compliance at its core. We provide compliance-ready reporting for audits and support the EU AI Act requirements for high-risk healthcare AI systems."
  },
  {
    question: "How does the integration process work?",
    answer: "We offer seamless integration with existing healthcare IT infrastructure and EMR/EHR systems. Our platform has been successfully tested with TensorFlow and PyTorch. Deployment options include cloud, on-premise, or hybrid to meet healthcare compliance requirements."
  },
  {
    question: "What types of organizations do you serve?",
    answer: "We serve the entire healthcare spectrum: from digital health startups and small clinics to mid-sized healthcare organizations, major health systems, Fortune 500 pharma companies, and large biotech organizations."
  },
  {
    question: "What is included in the onboarding process?",
    answer: "We provide white-glove onboarding and training for clinical teams, including a 30-day proof of concept pilot with measurable results. Our customer success team ensures smooth deployment and ongoing support."
  },
  {
    question: "When will the platform be fully available?",
    answer: "Our MVP launch is targeted for January 2026 with core security features for healthcare. We are currently at 90% development completion with beta program infrastructure ready for 5-8 organizations."
  }
];

export default function FAQSection() {
  return (
    <section className="py-24 lg:py-32 bg-white">
      <div className="max-w-3xl mx-auto px-6">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <p className="text-[#1e3a5f] text-sm font-medium tracking-wider uppercase mb-4">FAQ</p>
          <h2 className="text-4xl md:text-5xl font-light text-slate-900 mb-6">
            Frequently Asked Questions
          </h2>
        </motion.div>
        
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          {/* We removed type="single" as it's handled by our custom logic */}
          <Accordion className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`}
                className="border border-slate-200 rounded-xl px-6 transition-colors"
              >
                <AccordionTrigger className="text-left text-lg font-medium text-slate-900 hover:no-underline py-6">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-slate-600 pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}